import { DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { EmptyCell, type IColumn, Typography } from 'shared/ui'
import type { IClickToTextStatisticsClicks } from 'entities/ClickToText'

export const columns: IColumn<IClickToTextStatisticsClicks>[] = [
  {
    field: 'location',
    name: 'Location',
    width: '33.33%',
    renderRowCell: (row) => (
      <Typography
        variant={'body-md-regular'}
        color={'var(--content-primary-primary)'}
        ariaLabel={'Location'}
        ellipsis
        width={'100%'}
        tooltipProps={{
          label: row.location,
        }}
      >
        {row.location}
      </Typography>
    ),
  },
  {
    field: 'type',
    name: 'Device type',
    width: '33.33%',
    renderRowCell: (row) => (
      <Typography
        variant={'body-md-regular'}
        ariaLabel={'Device type'}
        ellipsis
        color={'var(--content-primary-primary)'}
      >
        {row.deviceType}
      </Typography>
    ),
  },
  {
    field: 'leads',
    name: 'Link opened / QR scanned',
    width: '33.33%',
    renderRowCell: (row) =>
      row.linkOpenedAt ? (
        <Typography
          variant={'body-md-regular'}
          ariaLabel={'Link opened / QR scanned'}
          ellipsis
          color={'var(--content-primary-primary)'}
        >
          {uiStore.dayjs(row.linkOpenedAt).format(DayjsFormats.fullWithAtDash2)}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
]
